import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";

function ProcessingDialog({ open }) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Processing Document</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 2 }}>
          <CircularProgress />
          <Typography>Processing your document, please wait...</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ProcessingDialog;
